import React from 'react'
import { Route, Switch } from 'react-router-dom'

const Register = React.lazy(() => import('./Pages/register'))
const CardsPress = React.lazy(() => import('./Pages/CardsPress'))
const SeccionFinanzas = React.lazy(() => import('./Pages/SeccionFinanzas'))
const SeccionMarketings = React.lazy(() => import('./Pages/SeccionMarketings'))
const SeccionTurismos = React.lazy(() => import('./Pages/SeccionTurismos'))
const SeccionITs = React.lazy(() => import('./Pages/SeccionITs'))
const SeccionSocios = React.lazy(() => import('./Pages/SeccionSocios'))
const Contacts = React.lazy(() => import('./Pages/Contacts'))
const CardsInstagram = React.lazy(() => import('./Pages/CardsInstagram'))
const CardsTourDesks = React.lazy(() => import('./Pages/CardsTourDesks'))
const CardsPartners = React.lazy(() => import('./Pages/CardsPartners'))
const CardsDestinos = React.lazy(() => import('./Pages/CardsDestinos'))
const TopPagesPress = React.lazy(() => import('./Pages/TopPagesPress'))
const TopPagesJoinUs = React.lazy(() => import('./Pages/TopPagesJoinUs'))
const TopPagesAboutUs = React.lazy(() => import('./Pages/TopPagesAboutUs'))
const CarouselTopPages = React.lazy(() => import('./Pages/CarouselTopPages'))
const Users = React.lazy(() => import('./Pages/Users'))
const Admin = React.lazy(() => import('./Pages/Admin'))
const MapaMistico = React.lazy(() => import('./Pages/mapaMistico'))
const MapaDiamante = React.lazy(() => import('./Pages/mapaDiamante'))
const TermsandConditions = React.lazy(() => import('./Pages/TermsAndConditions'))
const Press = React.lazy(() => import('./Pages/Press'))
const AboutUs = React.lazy(() => import('./Pages/AboutUs'))
const JoinUs = React.lazy(() => import('./Pages/JoinUs'))
const Dashboard = React.lazy(() => import('./Pages/dashboard'))
const LoginPage = React.lazy(() => import('./Pages/login'))
const UserHandling = React.lazy(() => import('./Pages/untitled'))

const App: React.FunctionComponent = (props: any) => {
  const routes = [
    {
      path: '/register',
      name: 'Register',
      component: Register,
    },
    {
      path: '/admin/CardsPress',
      name: 'CardsPress',
      component: CardsPress,
    },
    {
      path: '/admin/SeccionFinanzas',
      name: 'SeccionFinanzas',
      component: SeccionFinanzas,
    },
    {
      path: '/admin/SeccionMarketings',
      name: 'SeccionMarketings',
      component: SeccionMarketings,
    },
    {
      path: '/admin/SeccionTurismos',
      name: 'SeccionTurismos',
      component: SeccionTurismos,
    },
    {
      path: '/admin/SeccionITs',
      name: 'SeccionITs',
      component: SeccionITs,
    },
    {
      path: '/admin/SeccionSocios',
      name: 'SeccionSocios',
      component: SeccionSocios,
    },
    {
      path: '/Contacts',
      name: 'Contacts',
      component: Contacts,
    },
    {
      path: '/CardsInstagram',
      name: 'CardsInstagram',
      component: CardsInstagram,
    },
    {
      path: '/admin/CardsTourDesks',
      name: 'CardsTourDesks',
      component: CardsTourDesks,
    },
    {
      path: '/CardsPartners',
      name: 'CardsPartners',
      component: CardsPartners,
    },
    {
      path: '/admin/CardsDestinos',
      name: 'CardsDestinos',
      component: CardsDestinos,
    },
    {
      path: '/TopPagesPress',
      name: 'TopPagesPress',
      component: TopPagesPress,
    },
    {
      path: '/TopPagesJoinUs',
      name: 'TopPagesJoinUs',
      component: TopPagesJoinUs,
    },
    {
      path: '/TopPagesAboutUs',
      name: 'TopPagesAboutUs',
      component: TopPagesAboutUs,
    },
    {
      path: '/CarouselTopPages',
      name: 'CarouselTopPages',
      component: CarouselTopPages,
    },
    {
      path: '/admin/Users',
      name: 'Users',
      component: Users,
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
    },
    {
      path: '/Mistico/:id',
      name: 'Mapa Mistico',
      component: MapaMistico,
    },
    {
      path: '/DiamanteAdventure/:id',
      name: 'Mapa Diamante',
      component: MapaDiamante,
    },
    {
      path: '/TermsAndConditions',
      name: 'Terms and Conditions',
      component: TermsandConditions,
    },
    {
      path: '/Press',
      name: 'Press',
      component: Press,
    },
    {
      path: '/AboutUs',
      name: 'About Us',
      component: AboutUs,
    },
    {
      path: '/JoinUs',
      name: 'Join Us',
      component: JoinUs,
    },
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
    },
    {
      path: '/login',
      name: 'Login Page',
      component: LoginPage,
    },
    {
      path: '',
      name: 'User Handling',
      component: UserHandling,
    },
  ]

  const switchRoutes = (
    <Switch>
      {routes.map((prop, key) => {
        return <Route exact path={prop.path} component={prop.component} key={key} />
      })}
    </Switch>
  )

  return (
    <React.Fragment>
      <React.Suspense fallback={<span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>Loading</span>}>
        <React.Fragment>{switchRoutes}</React.Fragment>
      </React.Suspense>
    </React.Fragment>
  )
}

export default App
